import { BELL_NOTIFICATION } from "./type.action";
import NotificationsRest from '../services/NotificationRestAPI';


export const fetchTodayTask = (_id) => {
  return async (dispatch) => {
    let result = await NotificationsRest.getAllUserTasksGlobally(_id);
    dispatch(storeDataInBell(result));
  };
};

export const storeDataInBell = (task) => {
  return { type: BELL_NOTIFICATION, payload: task };
};
